import { ACTIONS } from '../../_config'
import { ActionExtended, PusherResponse } from '../../_config/interfaces/interfaces';

export interface PusherReducer {
  pusherData: Array<PusherResponse>;
}

const initialState: PusherReducer = {
  pusherData: []
};

const pusherReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.PUSHER.ADD_DATA:
        const filterData = state.pusherData?.filter(item => item.datasource_id !== action.payload.datasource_id)
        return {
            ...state,
            pusherData: [...filterData, action.payload]
        };
    case ACTIONS.RESET_REDUCER:
    case ACTIONS.PUSHER.RESET_DATA:
        return {
            ...state,
            pusherData: []
        };
    default:
      return state;
  }
};

export default pusherReducer;
